export default {"src":"/_next/static/media/logo-mob.7c8f35db.svg","height":67,"width":127,"blurWidth":0,"blurHeight":0};